var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 696,
    height: 14,
    viewBox: "0 0 696 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 243,
    height: 1,
    fill: "black",
    fillOpacity: 0.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 10,
    width: 244,
    height: 1,
    fill: "black",
    fillOpacity: 0.47
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 10,
    width: 80,
    height: 1,
    fill: "black",
    fillOpacity: 0.47
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 10,
    width: 80,
    height: 1,
    fill: "black",
    fillOpacity: 0.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.341 0L350.4 5.09791L347.341 10.1958L344.283 5.09791L347.341 0Z",
    fill: "#BE1E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M337 10.3412L342.098 7.28249L347.196 10.3412L342.098 13.4L337 10.3412Z",
    fill: "#BE1E2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3412L5.09791 7.28241L10.1958 10.3412L5.09791 13.3999L0 10.3412Z",
    fill: "black",
    fillOpacity: 0.47
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M685.196 10.3412L690.294 7.28241L695.392 10.3412L690.294 13.3999L685.196 10.3412Z",
    fill: "black",
    fillOpacity: 0.47
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M347.489 10.3412L352.587 7.28249L357.685 10.3412L352.587 13.4L347.489 10.3412Z",
    fill: "#BE1E2D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 10,
    r: 2,
    fill: "#BE1E2D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 347.5,
    cy: 9.5,
    r: 1.5,
    fill: "black",
    fillOpacity: 0.47
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 443,
    cy: 10,
    r: 2,
    fill: "#BE1E2D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.7c798994fc7921d820224abd5d9da2ba.svg";
export { ForwardRef as ReactComponent };